import { useNavigate } from "react-router-dom";
import { GraduationCap, School, Users, ArrowRight } from "lucide-react";

const audiences = [
  {
    icon: GraduationCap,
    title: "Voor leerlingen",
    text: "Ontdek stap voor stap je talenten, interesses en een studiekeuze die bij je past.",
    to: "/voor-leerlingen",
    featured: true,
  },
  {
    icon: School,
    title: "Voor scholen & mentoren",
    text: "Één LOB-platform met overzicht, voortgang en minder administratie.",
    to: "/voor-scholen",
    featured: false,
  },
  {
    icon: Users,
    title: "Voor ouders",
    text: "Zie hoe wij jouw kind helpen groeien naar een bewuste keuze.",
    to: "/informatie-ouders",
    featured: false,
  },
];

const AudienceEntrySection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-16 lg:py-20 animate-on-scroll">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center max-w-xl mx-auto mb-12">
          <span className="inline-block text-[11px] font-bold tracking-[0.2em] uppercase text-primary mb-4 px-3 py-1 bg-accent rounded-full">
            Waar sta jij?
          </span>
          <h2 className="text-2xl lg:text-3xl font-extrabold text-secondary leading-tight">
            Kies jouw startpunt.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {audiences.map((a) => (
            <button
              key={a.title}
              onClick={() => navigate(a.to)}
              className={`group relative overflow-hidden text-left rounded-3xl p-8 transition-all hover:-translate-y-1.5 ${
                a.featured
                  ? "bg-gradient-to-br from-primary via-primary to-[hsl(196,100%,38%)] text-primary-foreground shadow-large shadow-primary/25"
                  : "bg-card border border-border shadow-soft hover:shadow-large"
              }`}
            >
              {/* decorative glow */}
              <div
                className={`pointer-events-none absolute -top-10 -right-10 w-40 h-40 rounded-full blur-3xl transition-opacity ${
                  a.featured
                    ? "bg-primary-foreground/20"
                    : "bg-primary/10 opacity-0 group-hover:opacity-100"
                }`}
              />

              <div className="relative">
                <div
                  className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110 ${
                    a.featured
                      ? "bg-primary-foreground/15"
                      : "bg-primary/10"
                  }`}
                >
                  <a.icon
                    className={`w-8 h-8 ${
                      a.featured ? "text-primary-foreground" : "text-primary"
                    }`}
                  />
                </div>

                <h3
                  className={`text-xl font-extrabold mb-2 ${
                    a.featured ? "text-primary-foreground" : "text-secondary"
                  }`}
                >
                  {a.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed mb-6 ${
                    a.featured
                      ? "text-primary-foreground/85"
                      : "text-muted-foreground"
                  }`}
                >
                  {a.text}
                </p>

                <span
                  className={`inline-flex items-center gap-2 text-sm font-bold rounded-full px-4 py-2 transition-colors ${
                    a.featured
                      ? "bg-primary-foreground text-primary"
                      : "bg-accent text-primary group-hover:bg-primary group-hover:text-primary-foreground"
                  }`}
                >
                  Ontdek meer
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceEntrySection;
